/**
 * CurrencyInput (U5): NumericInput preconfigured for USD amounts —
 * `$` prefix, 2 decimals, right-aligned tabular numerals.
 */
import type { JSX } from 'react';
import { NumericInput, type NumericInputProps } from './NumericInput';

export interface CurrencyInputProps
  extends Omit<NumericInputProps, 'decimals' | 'prefix' | 'align' | 'mono' | 'trim'> {
  /** Negative amounts rejected by default (min 0). */
  allowNegative?: boolean;
}

export function CurrencyInput({
  allowNegative = false,
  min,
  step = 1,
  placeholder = '0.00',
  ...rest
}: CurrencyInputProps): JSX.Element {
  return (
    <NumericInput
      {...rest}
      min={min ?? (allowNegative ? undefined : 0)}
      step={step}
      decimals={2}
      prefix="$"
      align="end"
      mono
      placeholder={placeholder}
    />
  );
}
